import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

const initialImages = [
  {
    src: "assets/Person1.webp",
    name: "carousel.leaders.person1.name",
    description:
      "carousel.leaders.person1.description",
  },
  {
    src: "assets/Person2.webp",
    name: "carousel.leaders.person2.name",
    description:
      "carousel.leaders.person2.description",
  },
  {
    src: "assets/Person3.webp",
    name: "carousel.leaders.person3.name",
    description:
      "carousel.leaders.person3.description",
  },
  {
    src: "assets/Person4.webp",
    name: "carousel.leaders.person4.name",
    description:
      "carousel.leaders.person4.description",
  },
  {
    src: "assets/Person5.webp",
    name: "carousel.leaders.person5.name",
    description:
      "carousel.leaders.person5.description",
  },
  {
    src: "assets/Person6.webp",
    name: "carousel.leaders.person6.name",
    description:
      "carousel.leaders.person6.description",
  },
];


export default function Carousel() {
  const { t }=useTranslation();
  const [slidesToShow, setSlidesToShow] = useState(4);
  const sliderRef = useRef(null);

  // Conditionally reverse the images array for RTL layout
  const images = (document.documentElement.dir==="rtl") ? [...initialImages].reverse() : initialImages;

  useEffect(() => {
    const updateSlidesToShow = () => {
      const width = window.innerWidth;
      if (width >= 1024) {
        setSlidesToShow(4);
      } else if (width >= 768) {
        setSlidesToShow(3);
      } else if (width >= 480) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(1);
      }
    };

    updateSlidesToShow(); // Set slides count on initial load
    window.addEventListener("resize", updateSlidesToShow);
    return () => {
      window.removeEventListener("resize", updateSlidesToShow);
    };
  }, []);

  const settings = {
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: Math.min(slidesToShow, images.length), // Limit scroll count
    infinite: false,
    arrows: false,
    centerMode: false,
    initialSlide: 0,
  };

  return (
    <div className="w-full flex relative justify-start items-center">
      <div className="w-full max-w-7xl mx-auto py-8 rounded-lg px-4" id="team">
        {/* Header and Navigation Buttons */}
        <div className="flex w-full items-center justify-start md:justify-between py-4">
          <div>
            <h1 className="text-4xl">
              <sup>(5)</sup> {t("carousel.title")}
            </h1>
          </div>
          <div className="items-center gap-2 hidden md:flex rtl:flex-row-reverse">
            <div className="py-2">
              <button
                onClick={() => sliderRef.current.slickPrev()}
                className="text-black px-4 py-2 rounded-l-md hover:bg-gray-400"
              >
                <svg
                  width="16"
                  height="28"
                  viewBox="0 0 16 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 2.18311L2 14.1831L14 26.1831"
                    stroke="#272727"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div className="py-2">
              <button
                onClick={() => sliderRef.current.slickNext()}
                className="text-black px-4 py-2 rounded-r-md hover:bg-gray-400"
              >
                <svg
                  width="16"
                  height="28"
                  viewBox="0 0 16 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 26.1831L14 14.1831L2 2.18311"
                    stroke="#272727"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Slider Component */}
        <div className="w-full flex items-center justify-center">
          <div className="relative w-4/5 min-w-72 sm:w-full rounded-lg overflow-hidden px-2 bg-blue-tint">
            <Slider {...settings} ref={sliderRef} className="bg-blue-tint rounded-lg">
              {images.map((image, index) => (
                <div key={index} className="px-2 rounded-lg max-w-80">
                  <div className="bg-blue-tint text-left w-full px-2 py-4 rounded-lg rtl:text-right">
                    <img
                      src={image.src}
                      alt={image.name}
                      className="w-64 h-72 object-cover object-center mb-4 rounded-lg grayscale hover:grayscale-0 rtl:ml-auto"
                    />
                    <h3 className="text-lg flex gap-2 font-normal text-white mb-2 rtl:flex-row-reverse">
                      <svg
                        width="16"
                        height="11"
                        viewBox="0 0 16 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <line y1="9.68311" x2="16" y2="9.68311" stroke="white" />
                      </svg>
                      <span>{t(image.name)}</span>
                    </h3>
                    <p className="text-sm text-white rtl:text-right gray">{t(image.description)}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
